<template>
  <div class="p-3 mt-3">
    <validation-observer ref="observer">
      <div v-if="!isPreview" class="row">
        <div class="col-6">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              min_value: 'La cantidad mínima debe ser 1.',
              max_value: 'La cantidad máxima debe ser 100.',
            }"
            rules="required|numeric|max_value:100|min_value:1"
          >
            <custom-input
              v-model.number="model.quantity"
              :error="errors[0]"
              label="¿Cuantas localidades podrán ser añadidas?"
              type="number"
            />
          </validation-provider>
        </div>
        <div class="col-6" />
      </div>
      <div class="row">
        <div class="col-6">
          <div v-if="isReadOnly">
            <label class="data-label">
              Dirección (Línea 1)
            </label>
            <input class="form-control disabled" :disabled="true" type="text" />
          </div>
          <validation-provider v-else v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.addressLine1"
              custom-error-msg="El campo es requerido."
              :disabled="true"
              :error="errors[0]"
              label="Dirección (Línea 1)"
            />
          </validation-provider>
        </div>

        <div class="col-6">
          <div v-if="isReadOnly">
            <label class="data-label">
              Dirección (Línea 2)
            </label>
            <input class="form-control disabled" :disabled="true" type="text" />
          </div>

          <validation-provider v-else v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.addressLine2"
              custom-error-msg="El campo es requerido."
              :disabled="true"
              :error="errors[0]"
              label="Dirección (Línea 2)"
            />
          </validation-provider>
        </div>

        <div class="col-4">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="isReadOnly ? '' : 'required'"
          >
            <custom-drop-down
              id="participantType"
              v-model="model.state"
              :clearable="true"
              custom-error-msg="El campo es requerido"
              :disabled="true"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Estado"
              :options="states"
              placeholder="Seleccione Estado"
              @input="onStateChange"
            />
          </ValidationProvider>
        </div>

        <div class="col-4">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="isReadOnly ? '' : 'required'"
          >
            <custom-drop-down
              id="participantType"
              v-model="model.municipality"
              :clearable="true"
              custom-error-msg="El campo es requerido"
              :disabled="true"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Municipio"
              :options="municipalities"
              placeholder="Seleccione Municipio"
            />
          </ValidationProvider>
        </div>

        <div class="col-4">
          <div v-if="isReadOnly">
            <label class="data-label">
              Código Postal
            </label>
            <input class="form-control disabled" :disabled="true" type="text" />
          </div>
          <ValidationProvider v-else v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.postalCode"
              custom-error-msg="El campo es requerido"
              :disabled="true"
              :error="errors[0]"
              label="Código Postal"
              mask-type="ZipcodeExt"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 my-2 p-3 document-bg rounded-lg">
          <label class="data-label d-block mb-2">
            Fotos por dentro y fuera (Incluyendo los baños y lugar confidencial
            donde se mantienen los expedientes de los estudiante)
          </label>
          <div
            class="col-12 p-3 document-bg rounded-lg"
            style="background-color: #F1F6F4;"
          >
            <div v-if="isReadOnly">
              <label class="data-label">
                Archivo
              </label>
              <action-button
                class="w-100 disabled"
                :disabled="true"
                i="fas fa-file-plus"
                text="Presione aquí para anejar documento"
                variant="outline-grey mr-3 pl-3 pr-4"
              />
            </div>
            <validation-provider
              v-else
              v-slot="{ errors }"
              class="w-100"
              name="Documento"
              rules="required"
            >
              <custom-file-input
                ref="fileInput"
                v-model="model.attachment"
                :accept="'.pdf'"
                :attachment-id="model.Id"
                custom-error-msg="documento es requerido"
                display-style="normal"
                :error="errors[0]"
                label="Archivo:"
                label-position="left"
                :name="model.documentName"
                :on-download="() => {}"
              />
            </validation-provider>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
//components
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';

//services
import { getStates, getMunicipalities } from '@/modules/common/location.api.js';

//utils
const STATE_PUERTO_RICO = 40;

export default {
  name: 'LocalityForm',
  components: { CustomInput, CustomDropDown, CustomFileInput, ActionButton },
  mixins: [alertMixin],
  props: {
    isReadOnly: { type: Boolean, default: () => false },
    isPreview: {
      type: Boolean,
      default: () => false,
    },
    value: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      states: [],
      municipalities: [],
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    isPuertoRico() {
      return this.model.state?.id === STATE_PUERTO_RICO;
    },
  },
  mounted() {
    this.loadCatalogs();
  },
  methods: {
    async loadCatalogs() {
      try {
        const [states, municipalities] = await Promise.all([
          getStates(),
          getMunicipalities({ academicYearId: 0 }),
        ]);
        this.states = (states?.data || states) ?? [];
        this.municipalities = (municipalities?.data || municipalities) ?? [];

        const prIndex = this.states.findIndex(
          (s) => s.id === STATE_PUERTO_RICO
        );
        if (prIndex > -1) {
          const pr = this.states.splice(prIndex, 1)[0];
          this.states.unshift(pr);
        }
      } catch (e) {
        this.ShowToast(
          'Catálogos',
          'No fue posible cargar los catálogos.',
          'error'
        );
      }
    },
    onStateChange() {
      this.model.municipality = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  background-color: var(--vs-disabled-bg);
  cursor: var(--vs-disabled-cursor);
}

.ab-btn-outline-grey {
  background-color: #fafafa;
  border: #e2e2e2 solid 1px;
  color: #11291b;
}
</style>
